import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { ASharedModal, SharedModalContent, SharedModalFooter, SharedModalTitle } from 'views/components/SharedModal'
import { PreviewContainer } from './FIlesControl/styled'
import MessengerGallery from './MessengerGallery'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { DocumentFile } from 'modules/domain/types'

type Props = {
  html: string
  documents: DocumentFile[]
  sendMessage: () => void
  onClose: () => void
}

export const PublishPreview: FC<Props> = ({ onClose, html, documents, sendMessage }) => {
  const { t } = useTranslation('samples')

  return (
    <ASharedModal size="small" onClose={onClose} id="telegramPreview">
      <SharedModalTitle>{t('preview')}</SharedModalTitle>
      <SharedModalContent>
        <MessengerGallery documents={documents} />
        <PreviewContainer>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </PreviewContainer>
      </SharedModalContent>
      <SharedModalFooter>
        <ADefaultModalFooter
          onClose={onClose}
          confirmButtonText={t('common:send')}
          onConfirm={() => {
            sendMessage()
            onClose()
          }}
        />
      </SharedModalFooter>
    </ASharedModal>
  )
}
